(function () {
  var attempts = new WeakMap();
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    var host = form.closest && form.closest('[data-bb-active]');
    if (!host || !form.matches('[data-lp-buybox]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var attempt = attempts.get(form);
    if (attempt && attempt.busy) return;
    var once = event.submitter && event.submitter.matches('[data-lp-buy-once]');
    var row = once ? event.submitter : form.querySelector('.lp-offer__input:checked');
    if (!row) return;
    if (!attempt) {
      attempt = { added: false, codes: row.getAttribute('data-discount-codes') || '' };
      attempts.set(form, attempt);
    }
    attempt.busy = true;
    var controls = Array.from(form.querySelectorAll('button, input[type="radio"]'));
    controls.forEach(function (control) { control.disabled = true; });
    var error = form.querySelector('[data-bb-error]');
    if (!error) {
      error = document.createElement('p');
      error.setAttribute('data-bb-error', '');
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.hidden = true;
    var root = window.Shopify.routes.root;
    async function post(path, body) {
      var response = await fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!response.ok) throw new Error('Checkout request failed');
      return response.json();
    }
    try {
      if (!attempt.added) {
        var item = { id: row.getAttribute('data-variant-id'), quantity: Number(row.getAttribute('data-quantity')), properties: { _BB_offer: host.dataset.bbActive } };
        var plan = row.getAttribute('data-selling-plan');
        if (plan) item.selling_plan = plan;
        await post('cart/add.js', { items: [item] });
        attempt.added = true;
      }
      await post('cart/update.js', { discount: attempt.codes });
      window.location.assign(root + 'checkout');
    } catch (failure) {
      error.textContent = attempt.added ? 'Your item is in the cart. Please retry to apply your offer and continue to checkout.' : 'We could not add this item. Please try again.';
      error.hidden = false;
      controls.forEach(function (control) { control.disabled = attempt.added && control.matches('input[type="radio"], [data-lp-buy-once]'); });
      if (attempt.added) form.querySelector('[data-lp-submit]').textContent = 'Continue to checkout';
      else attempts.delete(form);
    } finally { attempt.busy = false; }
  }, true);
})();
